import type { ReactElement, ReactNode } from 'react';
import { useSessionRestore } from '@/features/auth/auth-queries';

/**
 * Holds the first paint until the silent refresh settles, so a reload with a
 * valid refresh cookie lands back on the dashboard instead of bouncing through
 * the sign-in screen. If the restore itself fails (offline, API down) the app
 * still renders and the route guard sends the person to sign in.
 */
export function SessionGate({ children }: { children: ReactNode }): ReactElement {
  const { isPending } = useSessionRestore();

  if (isPending) {
    return (
      <div className="flex min-h-dvh items-center justify-center bg-surface">
        <p className="text-caption text-fg-muted" role="status">
          Checking your session
        </p>
      </div>
    );
  }

  return <>{children}</>;
}
